import { gsap } from 'gsap';
import serviceDetailAnim from '../serviceDetailAnim.js';

function initFaqAccordion() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document
    .querySelectorAll('.p-service-detail__faq .c-faq__item')
    .forEach(item => {
      const trigger = item.querySelector('.c-faq__trigger');
      const answer = item.querySelector('.c-faq__answer');
      if (!trigger || !answer) return;

      if (item.hasAttribute('open')) {
        gsap.set(answer, { height: 'auto', overflow: '' });
      }

      trigger.addEventListener('click', e => {
        e.preventDefault();
        gsap.killTweensOf(answer);

        if (!item.hasAttribute('open')) {
          item.setAttribute('open', '');
          gsap.set(answer, { height: 0, overflow: 'hidden' });
          gsap.to(answer, {
            height: 'auto',
            duration: 0.4,
            ease: 'power3.out',
            onComplete: () => gsap.set(answer, { height: '', overflow: '' }),
          });
        } else {
          gsap.set(answer, { height: answer.offsetHeight, overflow: 'hidden' });
          gsap.to(answer, {
            height: 0,
            duration: 0.3,
            ease: 'power3.in',
            onComplete: () => {
              item.removeAttribute('open');
              gsap.set(answer, { height: '', overflow: '' });
            },
          });
        }
      });
    });
}

function init() {
  initFaqAccordion();
  serviceDetailAnim();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
